import React from 'react';
import { Row, Col, CustomInput } from 'reactstrap';

import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

const PedidosConfig = ({ state, setState }) => {
  return (
    <Row>
      <Col xs={12}>
        <CustomInput
          type="checkbox"
          id={`Filtro-Pedidos_AllowCrear`}
          label="Alta de Pedidos"
          checked={state.Pedidos_AllowCrear}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ Pedidos_AllowCrear: !state.Pedidos_AllowCrear }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-Pedidos_AllowCrearSinStock`}
          label="Alta de Pedidos con Artículos Sin Stock"
          checked={state.Pedidos_AllowCrearSinStock}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ Pedidos_AllowCrearSinStock: !state.Pedidos_AllowCrearSinStock }), 100);
          }}
        />
        <CustomInput
          type="checkbox"
          id={`Filtro-Stock_DescontarStockDeDepositos`}
          label="Alta de Pedidos actualiza Stock en Web"
          checked={state.Stock_DescontarStockDeDepositos}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ Stock_DescontarStockDeDepositos: !state.Stock_DescontarStockDeDepositos }), 100);
          }}
        />

        <div className="my-1 bg-info w-100 text-center"><small>SIGE: Exportación de Pedidos</small></div>

        <CustomInput
          type="checkbox"
          id={`Filtro-Pedidos_AllowExportar`}
          label="Exportar a SIGE"
          checked={state.Pedidos_AllowExportar}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ Pedidos_AllowExportar: !state.Pedidos_AllowExportar }), 100);
          }}
        />

        <div className="my-1 bg-info w-100 text-center"><small>MercadoPago: Certificados de Aplicación</small></div>
        <CustomInput
          type="checkbox"
          id={`Filtro-MP_Allow`}
          label="Redirección a MercadoPago"
          checked={state.MP_Allow}
          onClick={(evt) => {
            evt.preventDefault();
            setTimeout(() => setState({ MP_Allow: !state.MP_Allow }), 100);
          }}
        />

        <ParadigmaLabeledInput
          md={[6, 6]}
          disabled={!!!state.MP_Allow}
          label={"Clave Publica (Public Key)"}
          value={state.MP_Allow ? state.MP_PublicKey : ''}
          onChange={(evt) => setState({ MP_PublicKey: state.MP_Allow ? evt.target.value : '' })}
        />
        <ParadigmaLabeledInput
          md={[6, 6]}
          disabled={!!!state.MP_Allow}
          label={"Token de Acceso (Access Token)"}
          value={state.MP_Allow ? state.MP_AccessToken : ''}
          onChange={(evt) => setState({ MP_AccessToken: state.MP_Allow ? evt.target.value : '' })}
        />
      </Col>
    </Row>

  )
}
export default PedidosConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/PedidosConfig.js